import React from 'react';
import { Modal } from 'react-bootstrap';
import { FaTrashAlt } from 'react-icons/fa'; // Font Awesome delete icon

const DeleteConfirmationDialog = ({ show, onClose, onDelete, title = 'Are you sure?', description = 'This action cannot be undone.' }) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <div className="text-center" style={{padding:"1.5rem"}}>
                {/* Delete Icon */}
                <div className="mb-3 d-flex justify-content-center">
                    <div
                        className="bg-danger bg-opacity-10 text-danger rounded-circle d-flex align-items-center justify-content-center"
                        style={{ width: '80px', height: '80px' }}
                    >
                        <FaTrashAlt size={32} />
                    </div>
                </div>


                {/* Title */}
                <h5 className="fw-bold text-dark">{title}</h5>

                {/* Description */}
                <p className="text-secondary">{description}</p>

                {/* Buttons */}
                <div className="d-flex justify-content-center gap-3 mt-4">
                    <button
                        className="btn btn-outline-secondary px-10"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="btn btn-danger bg-danger px-10"
                        onClick={onDelete}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteConfirmationDialog;
